const BASE_KEYS = {
  referral: 'referral',
  auth: 'auth',
  user: 'user',
  investing: 'investing',
  loyalty: 'loyalty',
  common: 'common',
  cash: 'cash',
  marketing: 'marketing',
  brand: 'brand',
  dashboard: 'dashboard',
  calculator: 'calculator',
  report: 'report',
  loan: 'loan',
  blog: 'blog',
  complaint: 'complaint',
  question: 'question',
  history: 'history',
  streak: 'streak',
  compliance: 'compliance',
  quiz: 'quiz',
  chatwoot: 'chatwoot',
};

export const QUERY_KEYS = {
  referral: {
    validation: `${BASE_KEYS.referral}_validation`,
  },
  auth: {
    email_otp_status: `${BASE_KEYS.auth}_email_otp_status`,
    two_factor_otp_status: `${BASE_KEYS.auth}_two_factor_otp_status`,
  },
  user: {
    profile: `${BASE_KEYS.user}_profile`,
    veriff_status: `${BASE_KEYS.user}_veriff_status`,
    can_delete: `${BASE_KEYS.user}_can_delete`,
    phone_verify: `${BASE_KEYS.user}_phone_verify`,
  },
  investing: {
    status: `${BASE_KEYS.investing}_status`,
    repayment_schedule: `${BASE_KEYS.investing}_repayment_schedule`,
    pre_allocate_info: `${BASE_KEYS.investing}_pre_allocate_info`,
    fundraising_stats: `${BASE_KEYS.investing}_fundraising_stats`,
    invested_countries: `${BASE_KEYS.investing}_invested_countries`,
    participating_brands: `${BASE_KEYS.investing}_participating_brands`,
    fundraising_dates: `${BASE_KEYS.investing}_fundraising_dates`,
    allocate_info: `${BASE_KEYS.investing}_allocate_info`,
    result: `${BASE_KEYS.investing}_result`,
    invested_in_groups_stats: `${BASE_KEYS.investing}_invested_in_groups_stats`,
    investment_brands: `${BASE_KEYS.investing}_investment_brands`,
  },
  cash: {
    balance: `${BASE_KEYS.cash}_balance`,
    payment_methods: `${BASE_KEYS.cash}_payment_methods`,
    payment_calculated_amount: `${BASE_KEYS.cash}_payment_calculated_amount`,
    top_up_result: `${BASE_KEYS.cash}_top_up_result`,
    withdraw_info: `${BASE_KEYS.cash}_withdraw_info`,
    withdraw_history: `${BASE_KEYS.cash}_withdraw_history`,
    bank_accounts: `${BASE_KEYS.cash}_bank_accounts`,
    bank_account_detail: `${BASE_KEYS.cash}_bank_account_detail`,
    check_iban_number: `${BASE_KEYS.cash}_check_iban_number`,
    country_sepa_check: `${BASE_KEYS.cash}_country_sepa_check`,
  },
  loyalty: {
    status: `${BASE_KEYS.loyalty}_status`,
    levels: `${BASE_KEYS.loyalty}_levels`,
    reservation_limits: `${BASE_KEYS.loyalty}_reservation_limits`,
  },
  common: {
    countries: `${BASE_KEYS.common}_countries`,
    faq: `${BASE_KEYS.common}_faq`,
    decision_widget: `${BASE_KEYS.common}_decision_widget`,
  },
  marketing: {
    referral_code: `${BASE_KEYS.marketing}_referral_code`,
    bonus_groups: `${BASE_KEYS.marketing}_bonus_groups`,
    increased_income: `${BASE_KEYS.marketing}_increased_income`,
    referrals_list: `${BASE_KEYS.marketing}_referrals_list`,
  },
  brand: {
    detail_by_id: `${BASE_KEYS.brand}_detail_by_id`,
    detail_by_slug: `${BASE_KEYS.brand}_detail_by_slug`,
    active_brands: `${BASE_KEYS.brand}_active_brands`,
    inactive_brands: `${BASE_KEYS.brand}_inactive_brands`,
    active_founders: `${BASE_KEYS.brand}_active_founders`,
    inactive_founders: `${BASE_KEYS.brand}_inactive_founders`,
    founder_fr_status: `${BASE_KEYS.brand}_founder_fr_status`,
    founder_detail: `${BASE_KEYS.brand}_founder_detail`,
  },
  dashboard: {
    earnings: `${BASE_KEYS.dashboard}_earnings`,
    happy_brands: `${BASE_KEYS.dashboard}_happy_brands`,
    messages: `${BASE_KEYS.dashboard}_messages`,
  },
  calculator: {
    constants: `${BASE_KEYS.calculator}_constants`,
    growth_result: `${BASE_KEYS.calculator}_growth_result`,
    did_you_know: `${BASE_KEYS.calculator}_did_you_know`,
  },
  report: {
    activity_types: `${BASE_KEYS.report}_activity_types`,
    tax_report: `${BASE_KEYS.report}_tax_report`,
    cash_movements: `${BASE_KEYS.report}_cash_movements`,
    portfolio_movements: `${BASE_KEYS.report}_portfolio_movements`,
  },
  loan: {
    loan_list: `${BASE_KEYS.loan}_loan_list`,
    loans_by_fundraising_id: `${BASE_KEYS.loan}_loans_by_fundraising_id`,
    brands_by_fundraising_id: `${BASE_KEYS.loan}_brands_by_fundraising_id`,
    loan_earnings_by_fundraising_id: `${BASE_KEYS.loan}_loan_earnings_by_fundraising_id`,
    repayment_schedule_by_fundraising_id: `${BASE_KEYS.loan}_repayment_schedule_by_fundraising_id`,
    recovery_funds_by_fundraising_id: `${BASE_KEYS.loan}_recovery_funds_by_fundraising_id`,
    loan_payment_history_by_fundraising_id: `${BASE_KEYS.loan}_loan_payment_history_by_fundraising_id`,
    finance_agreements_by_fundraising_id: `${BASE_KEYS.loan}_finance_agreements_by_fundraising_id`,
    loan_security_by_fundraising_id: `${BASE_KEYS.loan}_loan_security_by_fundraising_id`,
    repayment_schedule: `${BASE_KEYS.loan}_repayment_schedule`,
  },
  blog: {
    articles: `${BASE_KEYS.blog}_articles`,
    article_detail: `${BASE_KEYS.blog}_article_detail`,
    banners: `${BASE_KEYS.blog}_banners`,
  },
  complaint: {
    list: `${BASE_KEYS.complaint}_list`,
    detail: `${BASE_KEYS.complaint}_detail`,
    participating_fundraising: `${BASE_KEYS.complaint}_participating_fundraising`,
  },
  question: {
    list: `${BASE_KEYS.question}_list`,
  },
  history: {
    all_rounds: `${BASE_KEYS.history}_all_rounds`,
    rounds_summary: `${BASE_KEYS.history}_rounds_summary`,
    countries_by_id: `${BASE_KEYS.history}_countries_by_id`,
    repayment_progress_by_id: `${BASE_KEYS.history}_repayment_progress_by_id`,
    brands_batch_by_id: `${BASE_KEYS.history}_brands_batch_by_id`,
    loan_groups_by_id: `${BASE_KEYS.history}_loan_groups_by_id`,
  },
  streak: {
    status: `${BASE_KEYS.streak}_status`,
    rewards: `${BASE_KEYS.streak}_rewards`,
    leaderboards: `${BASE_KEYS.streak}_leaderboards`,
    activity: `${BASE_KEYS.streak}_activity`,
    activity_infinity: `${BASE_KEYS.streak}_activity_infinity`,
  },
  compliance: {
    notifications: `${BASE_KEYS.compliance}_notifications`,
    detail: `${BASE_KEYS.compliance}_detail`,
  },
  quiz: {
    redirect_info: `${BASE_KEYS.quiz}_redirect_info`,
  },
  chatwoot: {
    identity: `${BASE_KEYS.chatwoot}_identity`,
  },
};
